"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5443],{

/***/ 95443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C12.1046 6 13 5.10457 13 4C13 2.89543 12.1046 2 11 2C9.89543 2 9 2.89543 9 4C9 5.10457 9.89543 6 11 6ZM19.9 18.6L17.9 13.6C17.8 13.2 17.4 13 17 13H12V9C12 8.4 11.6 8 11 8C10.4 8 10 8.4 10 9V14C10 14.6 10.4 15 11 15H16.3L18 19.4C18.2 19.8 18.5 20 18.9 20C19 20 19.1 20 19.3 19.9C19.9 19.7 20.1 19.1 19.9 18.6ZM10 20.0004C11.4 20.0004 12.8 19.4004 13.8 18.3004C14.1 17.9004 14.7 17.9004 15.1 18.2004C15.5 18.6004 15.6 19.2004 15.2 19.6004C13.9 21.1004 12 22.0004 10 22.0004C6.1 22.0004 3 18.9004 3 15.0004C3 12.8004 4.1 10.6004 5.9 9.30044C6.4 9.00044 7 9.00044 7.3 9.50044C7.6 10.0004 7.5 10.6004 7.1 10.9004C5.8 11.9004 5 13.4004 5 15.0004C5 17.8004 7.2 20.0004 10 20.0004Z"
}), "Accessible"));


/***/ })

}]);